import Component from './user_invite_dialog.vue'
export default Component
